import React, { useContext, useCallback, useEffect } from "react";
import { Header } from "./Header";
import { Link } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";
import { notificationsThunk } from "../store/actions/notifications/notification.thunk";
import { useDispatch, useSelector } from "react-redux";

export const Sidebar = () => {
  const { logout, user } = useContext(AuthContext);
  const { unreadNotifications } = useSelector((state) => state.notifications);
  const dispatch = useDispatch();

  const getUnreadNotifications = useCallback(async () => {
    await dispatch(notificationsThunk.getUnreadNotifications());
  }, [dispatch]);

  useEffect(() => {
    getUnreadNotifications();
  }, []);

  return (
    <React.Fragment>
      <Header />
      <div className="left side-menu">
        <div className="slimscroll-menu" id="remove-scroll">
          <div id="sidebar-menu">
            <ul className="metismenu" id="side-menu">
              <li title="Home">
                <Link to="/dashboard/index">
                  {" "}
                  <img alt="home" src="/img/home ic.png" />
                </Link>
              </li>

              <li title="Notifications">
                <Link to="/notification">
                  <img
                    alt="notification"
                    src="/img/alert.png"
                    width="30px"
                    height="40px"
                  />
                  <span class="badge badge-pill badge-warning notification-icon">
                    {unreadNotifications.length}
                  </span>
                </Link>
              </li>

              <li title="Calendar">
                <Link to="/dashboard/calendar">
                  {" "}
                  <img alt="calendar" src="/img/calendar.png" />
                </Link>
              </li>

              {user.data.user.roles && user.data.user.roles.name === "admin" || user.data.user.roles.name === "human resource" ? (
                <li title="Settings">
                  <Link to="/dashboard/system-configuration">
                    {" "}
                    <img alt="settings" src="/img/settings.png" />
                  </Link>
                </li>
              ) : null}

              <br></br>
              <li title="Logout">
                <Link onClick={logout}>
                  {" "}
                  <img alt="logout" src="/img/logout.png" />
                </Link>
              </li>
            </ul>
          </div>

          <div className="clearfix"></div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Sidebar.js